import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';

const BreadCrumbs = ({
  items,
  onBackClick,
  hideBreadCrumbs,
  additionalContent,
}) => {
  const breadCrumbClass = hideBreadCrumbs ? 'breadcrumb d-none' : 'breadcrumb mb-0 align-items-center';
  const isBackClickFunction = typeof onBackClick === 'function';

  return (
    <nav aria-label='breadcrumb'>
      <div className='d-flex justify-content-between mb-3'>
        <ol className={breadCrumbClass}>
          {isBackClickFunction && onBackClick && (
            <li className='pointer pe-2'>
              <Button
                ghost
                onClick={onBackClick}
                className='text-reset text-decoration-none bg-transparent p-0'
              >
                <span
                  className='back fas fa-chevron-left'
                  aria-label='Back'
                  data-cy='breadcrumb-back'
                />
              </Button>
            </li>
          )}
          {items &&
            items.map((d, i) => {
              const isLastItem = i === items.length - 1;
              return (
                <Fragment key={i}>
                  <li
                    className={`breadcrumb-item ${isLastItem ? 'active' : ''} ${d.disabled ? 'disabled' : ''}`}
                  >
                    {d.onClick && !d.disabled
                      ? <Button
                        ghost
                        onClick={d.onClick}
                        className='text-reset text-decoration-none bg-transparent fw-normal p-0'
                        aria-current={isLastItem ? 'page' : false}
                      >
                        {d.text}
                      </Button>
                      : <span aria-disabled={true}>{d.text}</span>
                    }
                  </li>
                </Fragment>
              );
            })}
        </ol>
        {additionalContent && <>{additionalContent}</>}
      </div>
    </nav>
  );
};

BreadCrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any),
  onBackClick: PropTypes.func,
  hideBreadCrumbs: PropTypes.bool,
  additionalContent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
  ]),
};

export default BreadCrumbs;
